import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router';

import { actions, selectors } from 'src/store';
import { gameKeys, paths } from 'src/constants';
import Container from 'src/components/pages/Activities/Memory/Levels/Container';

const TIMEOUT_DURATION = 500;

const MemoryStepOneExtraLevels = ({
  getLevelsByCollectionId,
  hasLoaded,
  currency,
  levels,
  student,
  unlockCollection,
  updateFeedback,
}) => {
  const history = useHistory();
  const gameKey = gameKeys.MEMORY_STEP_ONE_EXTRA;
  const { groupKey, activityId, groupId, collectionId } = useParams();

  const handleLevelAnswer = (levelId, isCorrect, currencyId) => {
    updateFeedback({ currencyId, gameKey, levelId, isCorrect });
  };

  const handleCollectionEnd = () => {
    unlockCollection({ gameKey, collectionId });
    setTimeout(() => {
      history.replace(
        paths.build(
          paths.MEMORY_STEP_ONE_EXTRA_COLLECTIONS,
          groupKey,
          activityId,
          groupId
        )
      );
    }, TIMEOUT_DURATION);
  };

  useEffect(() => {
    getLevelsByCollectionId(collectionId);
  }, [getLevelsByCollectionId, collectionId]);

  return (
    <Container
      cardClassName="memory-level-card-container--step-one-extra"
      className="memory-levels-container--step-one-extra"
      currency={currency}
      hasLoaded={hasLoaded}
      items={levels}
      handleLevelAnswer={handleLevelAnswer}
      handleCollectionEnd={handleCollectionEnd}
      student={student}
    />
  );
};

MemoryStepOneExtraLevels.propTypes = {
  getLevelsByCollectionId: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  currency: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  levels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  student: PropTypes.shape({}).isRequired,
  unlockCollection: PropTypes.func.isRequired,
  updateFeedback: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.memoryStepOneExtraLevels.getHasLoaded(state),
  currency: selectors.memoryStepOneExtraLevels.getCurrencyData(state),
  levels: selectors.memoryStepOneExtraLevels.getLevelsData(state),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.memoryStepOneExtra,
  ...actions.feedback,
  ...actions.students,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(MemoryStepOneExtraLevels);
